module.exports = __webpack_public_path__ + "img/3.ae34f6ef.png";